export const getDaysToNow = (date: Date): number => {
  const now = new Date();
  const diffInDays = Math.abs(now.getTime() - date.getTime());
  return Math.ceil(diffInDays / (1000 * 3600 * 24));
};
